/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function setNaviBarRightItem(params) {
    // 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    var formatInput = function (options) { return ({
        buttonText: options === null || options === void 0 ? void 0 : options.title,
        imageURL: options === null || options === void 0 ? void 0 : options.iconBase64,
        showButton: true,
        imagePosition: 'right',
        // onClick: options?.onClick, // 菜鸟不支持直接onClick回调
    }); };
    WVCall('CNHybridNavigationBar.setRightBarButton', params, { formatInput: formatInput });
}

export { setNaviBarRightItem as default };
